"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorTierWidget = void 0;
var journey_services_1 = require("@athena-portal/journey-services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var services_1 = require("@falcon/services");
var PremiumTypeSwitchWidget_1 = require("./PremiumTypeSwitchWidget");
var AnnualMotorTierTableWidget_1 = require("./tierTable/AnnualMotorTierTableWidget");
var AnnualMotorTierUpgradeModalConditions_1 = require("../../../helpers/annual/motor/AnnualMotorTierUpgradeModalConditions");
var AnnualMotorTierUpgradeModals_1 = require("../../../helpers/annual/motor/AnnualMotorTierUpgradeModals");
var NoPriceForMotorTierModal_1 = require("./NoPriceForMotorTierModal");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualMotorTierWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorTierWidget, _super);
    function AnnualMotorTierWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleNoPriceForTierModal = function () {
            _this.setState({
                showNoPriceForTierModal: !_this.state.showNoPriceForTierModal
            });
        };
        _this.state = {
            showModalEssentialsGHCSelected: false,
            showModalEssentialsMLESelected: false,
            showModalSilverMLESelected: false,
            showModalEssentialsGHCAndMLESelected: false,
            showModalSilverGHCAndMLESelected: false,
            showNoPriceForTierModal: false,
            initialTier: _this.props.interaction.coverTier,
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleAddonChangeEvent = _this.handleAddonChangeEvent.bind(_this);
        _this.switchPremiumType = _this.switchPremiumType.bind(_this);
        _this.switchTier = _this.switchTier.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        _this.navigateToEditRenewal = _this.navigateToEditRenewal.bind(_this);
        return _this;
    }
    AnnualMotorTierWidget.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.props.interaction.uistate.previousCoverTier) {
                    journey_services_1.ObjectManipulator.setField("uistate.previousCoverTier", this.props.interaction, this.props.interaction.coverTier);
                }
                return [2 /*return*/];
            });
        });
    };
    AnnualMotorTierWidget.prototype.render = function () {
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        if (eligibleTiers && eligibleTiers.length < 2) {
            return React.createElement(React.Fragment, null);
        }
        else {
            var showPremiumTypeSwitch = this.props.process === services_1.INTERACTION_PROCESS_NB
                || this.isMTCRenewal()
                || this.props.process === services_1.INTERACTION_PROCESS_MTC
                || this.props.process === services_1.INTERACTION_PROCESS_RENEWAL;
            return (React.createElement("div", { className: "annual-motor-tier-widget" },
                this.getHeader(),
                showPremiumTypeSwitch && this.notAnnualOnly() &&
                    React.createElement(PremiumTypeSwitchWidget_1.PremiumTypeSwitchWidget, { interaction: this.props.interaction, executePremiumChange: this.switchPremiumType }),
                React.createElement(AnnualMotorTierTableWidget_1.AnnualMotorTierTableWidget, { interaction: this.props.interaction, interactionField: this.props.question.interactionField, onAddonChange: this.handleAddonChangeEvent, handleChange: this.handleChange }),
                this.renderIncludedTaxSection(),
                (0, AnnualMotorTierUpgradeModals_1.getAnnualMotorTierUpgradeModals)(this.state, this.switchTier, this.closeModal, this.bindFromField.bind(this)),
                React.createElement(NoPriceForMotorTierModal_1.default, { closeModal: this.toggleNoPriceForTierModal, isOpen: this.state.showNoPriceForTierModal, isNB: this.props.process === services_1.INTERACTION_PROCESS_NB, interaction: this.props.interaction })));
        }
    };
    AnnualMotorTierWidget.prototype.getHeader = function () {
        var _a, _b, _c;
        var isMonthly = ((_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.factors.premiumType) === services_1.PREMIUM_TYPE_MONTHLY;
        var isMta = ((_b = this.props.interaction) === null || _b === void 0 ? void 0 : _b.status) === services_1.INTERACTION_STATUS_PENDING_MTA;
        return ((_c = this.props.interaction) === null || _c === void 0 ? void 0 : _c.source) || isMta ?
            React.createElement(React.Fragment, null,
                React.createElement("h2", { className: "text-blue-2 quote-section-title" }, "Choose the cover that's right for you"),
                React.createElement("p", { className: "quote-section-description" }, this.getQuoteDescriptionWording()),
                isMta && React.createElement("p", null,
                    "See below your ",
                    isMonthly ? "monthly" : "annual",
                    " price if you'd selected this cover level from the start of your policy.")) :
            React.createElement(React.Fragment, null,
                React.createElement("p", { className: "quote-section-description" },
                    "Please check your options below.",
                    React.createElement("br", null),
                    this.getQuoteDescriptionWording()),
                React.createElement("h2", { className: "text-blue-2 quote-section-title" }, "Choose the cover that's right for you"));
    };
    AnnualMotorTierWidget.prototype.getQuoteDescriptionWording = function () {
        return this.props.interaction.tieredCovers.length === 2 ?
            "With just two levels of cover it’s easy to select the one that you need." :
            "With three levels of cover it’s easy to select the one that you need.";
    };
    AnnualMotorTierWidget.prototype.isMTCRenewal = function () {
        var referrerJourney = this.getSetting("referrerJourney", "");
        return referrerJourney === services_1.INTERACTION_PROCESS_RENEWAL_CANCELLATION;
    };
    AnnualMotorTierWidget.prototype.notAnnualOnly = function () {
        return this.props.interaction.polarisPolicyData.instalmentAllowedStatus === 'A';
    };
    AnnualMotorTierWidget.prototype.renderIncludedTaxSection = function () {
        var premiumType = this.props.interaction.factors.premiumType;
        return (React.createElement("div", { className: "included-tax-section margin-top-48" },
            React.createElement("p", null,
                "* All figures include ",
                premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
                    'Insurance Premium Tax' : 'Interest and Insurance Premium Tax')));
    };
    AnnualMotorTierWidget.prototype.navigateToEditRenewal = function () {
        journey_services_1.ObjectManipulator.setField("uistate.interactionChangesDetected", this.props.interaction, true);
        this.props.engine.navigate("viewAndEditRenewalProposalPage", false);
    };
    AnnualMotorTierWidget.prototype.handleChange = function (selectedTier) {
        if ((0, commonFunctions_1.hasPriceForTier)(selectedTier, this.props.interaction.coverTier, this.props.interaction.tieredFactors)) {
            journey_services_1.ObjectManipulator.setField(this.props.question.interactionField, this.props.interaction, selectedTier);
            journey_services_1.ObjectManipulator.setField("uistate.selectedCoverTier", this.props.interaction, selectedTier);
            journey_services_1.ObjectManipulator.setField("uistate.interactionChangesDetected", this.props.interaction, true);
            (0, commonFunctions_1.handleChanged)(this.props.question.interactionField, this.props.interaction, this.state.initialTier, selectedTier);
            this.executeEvent("change");
        }
        else {
            this.toggleNoPriceForTierModal();
        }
    };
    AnnualMotorTierWidget.prototype.switchPremiumType = function () {
        var _this = this;
        var newPremiumType = this.props.interaction.factors.premiumType === "annual" ? "monthly" : "annual";
        var tieredFactors = this.props.interaction.tieredFactors;
        if (tieredFactors.length > 0) {
            tieredFactors.forEach(function (factors, index) {
                _this.props.onStateChange("tieredFactors[".concat(index, "].premiumType"), newPremiumType);
            });
        }
        this.props.onStateChange("factors.premiumType", newPremiumType);
        journey_services_1.ObjectManipulator.setField("uistate.interactionChangesDetected", this.props.interaction, true);
    };
    AnnualMotorTierWidget.prototype.handleAddonChangeEvent = function (event, addonField, addonValue) {
        var removeBreakdownCover = addonField === "optionalExtras.breakdownCover" && addonValue;
        if (addonField !== "optionalExtras.breakdownCover" || removeBreakdownCover) {
            if (removeBreakdownCover) {
                journey_services_1.ObjectManipulator.setField("optionalExtras.breakdownCoverLevel", this.props.interaction, null);
            }
            journey_services_1.ObjectManipulator.setField("uistate.tierOptionalExtrasChanged", this.props.interaction, true);
        }
        this.props.onStateChange(addonField, !addonValue);
        journey_services_1.ObjectManipulator.setField("uistate.interactionChangesDetected", this.props.interaction, true);
        !addonValue ? !this.showModal() && this.executeEvent("blur") : this.executeEvent("blur");
    };
    AnnualMotorTierWidget.prototype.showModal = function () {
        var conditions = (0, AnnualMotorTierUpgradeModalConditions_1.getModalConditions)(this.bindFromField.bind(this), this.props.interaction);
        var _loop_1 = function (condition) {
            if (!condition.isModalShown && condition.conditionCheck()) {
                this_1.setState(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[condition.stateKey] = true, _a)));
                });
                journey_services_1.ObjectManipulator.setField(condition.uiStateKey, this_1.props.interaction, true);
                return { value: true };
            }
        };
        var this_1 = this;
        for (var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++) {
            var condition = conditions_1[_i];
            var state_1 = _loop_1(condition);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return false;
    };
    AnnualMotorTierWidget.prototype.closeModal = function (modalStateKey) {
        this.setState(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[modalStateKey] = false, _a)));
        });
        this.executeEvent("blur");
    };
    AnnualMotorTierWidget.prototype.switchTier = function (tier, modalStateKey) {
        journey_services_1.ObjectManipulator.setField("coverTier", this.props.interaction, tier);
        journey_services_1.ObjectManipulator.setField("uistate.selectedCoverTier", this.props.interaction, tier);
        this.closeModal(modalStateKey);
    };
    return AnnualMotorTierWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorTierWidget = AnnualMotorTierWidget;
//# sourceMappingURL=AnnualMotorTierWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualMotorTierWidget.js
// module id = 3226
// module chunks = 0